module.exports = __webpack_public_path__ + "img/file-icon.330c6451.svg";